(function () {
  if (window.__uplianceFeatureTourLoaded) return;
  window.__uplianceFeatureTourLoaded = true;
  var lastScroll = -1e9;
  var pointerDown = null;

  document.addEventListener('scroll', function () { lastScroll = performance.now(); }, { capture: true, passive: true });
  document.addEventListener('pointerdown', function (event) {
    if (!event.target.closest || !event.target.closest('[data-uft-toggle]')) return;
    pointerDown = { x: event.clientX, y: event.clientY, time: performance.now(), scrolling: performance.now() - lastScroll < 200 };
  }, { capture: true, passive: true });

  function cleanTap(event) {
    if (event.detail === 0 || !window.PointerEvent) return true;
    var now = performance.now();
    var start = pointerDown;
    pointerDown = null;
    if (now - lastScroll < 200) return false;
    if (!start) return true;
    if (start.scrolling || now - start.time > 600) return false;
    return Math.hypot(event.clientX - start.x, event.clientY - start.y) <= 10;
  }

  function initFeatureTour(root) {
    if (!root || root.dataset.uftInitialized === 'true') return;

    var track = root.querySelector('[data-uft-track]');
    var cards = track ? Array.prototype.slice.call(track.querySelectorAll('[data-uft-card]')) : [];
    var previous = root.querySelector('[data-uft-prev]');
    var next = root.querySelector('[data-uft-next]');
    var count = root.querySelector('[data-uft-count]');
    var progress = root.querySelector('[data-uft-progress]');
    var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-uft-toggle]'));

    if (!track || !cards.length || !previous || !next) return;
    root.dataset.uftInitialized = 'true';

    function nearestCardIndex() {
      var trackLeft = track.getBoundingClientRect().left;
      var bestIndex = 0;
      var bestDistance = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      return bestIndex;
    }

    function updateState() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll - 2;
      var current = nearestCardIndex();

      previous.disabled = atStart;
      next.disabled = atEnd;
      if (count) count.textContent = (current + 1) + ' / ' + cards.length;
      if (progress) progress.style.transform = 'scaleX(' + (maxScroll ? Math.max(0, Math.min(1, track.scrollLeft / maxScroll)) : 1) + ')';
    }

    function scrollOneCard(direction) {
      var current = nearestCardIndex();
      var target = cards[Math.max(0, Math.min(cards.length - 1, current + direction))];
      if (target) target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
    }

    previous.addEventListener('click', function () { scrollOneCard(-1); });
    next.addEventListener('click', function () { scrollOneCard(1); });

    function updateCardState(toggle) {
      var open = toggle.dataset.uftOpen === 'true';
      var preview = toggle.dataset.uftPreview === 'true' && !open;
      var revealed = open || preview;
      toggle.setAttribute('aria-expanded', String(revealed));
      var front = toggle.querySelector('[data-uft-front]');
      var back = toggle.querySelector('[data-uft-back]');
      if (front) front.setAttribute('aria-hidden', String(revealed));
      if (back) back.setAttribute('aria-hidden', String(!revealed));
    }

    function setOpen(toggle, open) {
      toggle.dataset.uftOpen = String(open);
      toggle.dataset.uftPreview = 'false';
      updateCardState(toggle);
    }

    function setPreview(toggle, preview) {
      toggle.dataset.uftPreview = String(preview);
      updateCardState(toggle);
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('pointerenter', function () {
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && toggle.dataset.uftHoverDismissed !== 'true') {
          setPreview(toggle, true);
        }
      });
      toggle.addEventListener('pointerleave', function () {
        setPreview(toggle, false);
        delete toggle.dataset.uftHoverDismissed;
      });
      toggle.addEventListener('focus', function () { setPreview(toggle, true); });
      toggle.addEventListener('blur', function () {
        if (toggle.dataset.uftOpen !== 'true') setPreview(toggle, false);
      });
      toggle.addEventListener('click', function (event) {
        if (!cleanTap(event)) return;
        var open = toggle.dataset.uftOpen !== 'true';
        setOpen(toggle, open);
        if (!open && window.matchMedia('(hover: hover) and (pointer: fine)').matches && toggle.matches(':hover')) {
          toggle.dataset.uftHoverDismissed = 'true';
        }
      });
    });
    track.addEventListener('scroll', updateState, { passive: true });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollOneCard(event.key === 'ArrowRight' ? 1 : -1);
      } else if (event.key === 'Escape') {
        toggles.forEach(function (toggle) { setOpen(toggle, false); });
      }
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateState).observe(track);
    } else {
      window.addEventListener('resize', updateState);
    }

    updateState();
  }

  function initWithin(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-uft-root]')) initFeatureTour(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-uft-root]').forEach(initFeatureTour);
    }
  }

  initWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); });
})();
